import jaShareText from '@kurotetsu/share/i18n/lang/ja';
import jaUI from '@linktivity/link-ui/lang/ja';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import jaPublicText from './lang/ja';

export const DEFAULT_LOCALE = 'ja';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export const resources = {
  ja: {
    translation: {
      ...jaUI,
      ...jaShareText,
      ...jaPublicText,
      common: {
        ...jaShareText.common,
        ...jaPublicText.common
      },
      error: {
        ...jaShareText.error,
        ...jaPublicText.error
      }
    }
  }
} as const;

void i18n.use(initReactI18next).init({
  lng: DEFAULT_LOCALE,
  returnNull: false,
  resources,
  interpolation: { escapeValue: false }
});

document.documentElement.setAttribute('lang', DEFAULT_LOCALE);

export default i18n;
